if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
      class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitting = false;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getMainQuantityInput() {
        return document.querySelector('.quantity_selector-buy_buttons .quantity__input');
      }

      isMainBuyForm() {
        return Boolean(this.closest('.quantity_selector-buy_buttons'));
      }

      setAtcStockDisabled(disabled) {
        if (!this.submitButton) return;

        if (this.submitButton.hasAttribute('disabled')) {
          if (!disabled) return;
        }

        if (disabled) {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else if (!this.submitButton.classList.contains('loading') && !this.submitting) {
          this.submitButton.removeAttribute('aria-disabled');
        }

        const sticky = document.querySelector('.js-AddToCart_Submit');
        if (!sticky) return;
        if (disabled || this.submitButton.classList.contains('loading') || this.submitting) {
          sticky.setAttribute('aria-disabled', 'true');
        } else {
          sticky.removeAttribute('aria-disabled');
        }
      }

      showMaxQuantityError(maxQuantity) {
        const sectionId = this.dataset.sectionId;
        const adjusterError =
          (sectionId && document.querySelector(`.qty-Adjuster_Error[data-id="${sectionId}"]`)) ||
          document.querySelector('.quantity_selector-buy_buttons .qty-Adjuster_Error');
        if (adjusterError) {
          adjusterError.classList.remove('hd-Dnone');
          const maxText = adjusterError.querySelector('[data-el="quantity-adjuster.maxQuantityText"]');
          if (maxText && window.cartStrings?.quantityError && maxQuantity != null) {
            maxText.innerHTML = window.cartStrings.quantityError.replace('[quantity]', maxQuantity);
          }
        }

        const quantityError = document.querySelector('.prd-ProductOffers_Error');
        if (quantityError) {
          quantityError.style.display = 'block';
          setTimeout(() => {
            quantityError.style.display = 'none';
          }, 8000);
        }
      }

      async syncStockLimitState() {
        if (!this.isMainBuyForm()) return true;

        const productType = this.form.getAttribute('data-productType');
        const templateSuffix = this.form.getAttribute('data-surffix');
        if (productType === 'Swatch' || templateSuffix === 'gift-card') {
          this.setAtcStockDisabled(false);
          return true;
        }

        const handle = this.form.getAttribute('data-handle');
        const quantityInput = this.getMainQuantityInput();
        const quantity = parseInt(quantityInput?.value, 10) || 1;
        const variantInput = this.form.querySelector('[name="id"]');
        const keyid = variantInput ? String(variantInput.value) : '';

        try {
          const variantId = keyid;
          if (typeof invalidateProductMaxQuantityCache === 'function') {
            invalidateProductMaxQuantityCache(variantId);
          }
          const productMaxQuantities = await getProductMaxQuantity(`/products/${handle}`, variantId);
          const stock = productMaxQuantities?.[keyid];
          if (!stock || stock.unlimited) {
            this.setAtcStockDisabled(false);
            return true;
          }

          const max = Number(stock.max);
          const canAdd = Number.isFinite(max) && quantity > 0 && quantity <= max;
          this.setAtcStockDisabled(!canAdd);
          return canAdd;
        } catch (error) {
          console.error(error);
          this.setAtcStockDisabled(true);
          return false;
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitting) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const handle = this.form.getAttribute('data-handle');
        const productType = this.form.getAttribute('data-productType');
        const templateSuffix = this.form.getAttribute('data-surffix');
        let quantity = 1;
        const quantityInput = this.getMainQuantityInput();
        if (quantityInput) {
          quantity = parseInt(quantityInput.value, 10) || 1;
        }

        this.submitting = true;
        this.setAtcStockDisabled(true);

        if (productType != 'Swatch' && templateSuffix != 'gift-card' && this.isMainBuyForm()) {
          try {
            const keyid = String(this.form.querySelector('[name="id"]')?.value || '');
            const productMaxQuantities = await getProductMaxQuantity(`/products/${handle}`, keyid);
            const stock = productMaxQuantities?.[keyid];
            if (stock && !stock.unlimited) {
              const max = Number(stock.max);
              const totalAvailable = Number(stock.totalAvailable);
              if (!Number.isFinite(max) || quantity > max) {
                const displayMax = Number.isFinite(totalAvailable) ? totalAvailable : max;
                this.showMaxQuantityError(displayMax);
                this.submitting = false;
                this.setAtcStockDisabled(true);
                return;
              }
            }
          } catch (error) {
            console.error(error);
            this.submitting = false;
            this.setAtcStockDisabled(true);
            return;
          }
        } else if (productType === 'Swatch') {
          const { swatchCount, isSwatchInCart } = await this.getSwatchCountAndCheckInCart();

          if (swatchCount >= 4 || isSwatchInCart) {
            const quantityError = document.querySelector('.prd-ProductOffers_Error');
            if (quantityError) {
              quantityError.style.display = 'block';
              quantityError.textContent = isSwatchInCart
                ? 'You can only add one quantity of the same swatch product to the cart.'
                : 'You cannot add more than 4 swatch products to the cart.';
              setTimeout(() => {
                quantityError.style.display = 'none';
              }, 8000);
            }
            this.submitting = false;
            this.setAtcStockDisabled(false);
            return;
          }
        }

        let giftName, giftRName, giftEmail, giftComment, giftRadioValue = false;
        if (document.querySelector('.gift-card-radio input[type="radio"]') != null) {
          giftRadioValue = document.querySelector('.gift-card-radio input[type="radio"]:checked').value;
        }
        if (templateSuffix === 'gift-card' && giftRadioValue === 'true') {
          giftName = document.querySelector('input[name="properties[From]"]').value;
          giftRName = document.querySelector('input[name="properties[Recipient Name]"]').value;
          giftEmail = document.querySelector('input[name="properties[Recipient Email Address]"]').value;
          giftComment = document.querySelector('textarea[name="properties[Message]"]').value;

          const giftErrorEl = document.querySelector('.gift-card-field_error');
          let errorMessage = '';

          if (giftName === '' && giftEmail === '' && giftRName === '') {
            errorMessage = 'Email, sender name, and recipient name fields are required';
          } else if (giftName === '') {
            errorMessage = 'Sender name field is required';
          } else if (giftRName === '') {
            errorMessage = 'Recipient name field is required';
          } else if (giftEmail === '') {
            errorMessage = 'Email field is required';
          } else if (!this.isValidEmail(giftEmail)) {
            errorMessage = 'Invalid email format';
          }

          if (errorMessage) {
            giftErrorEl.querySelector('span').innerHTML = errorMessage;
            giftErrorEl.classList.remove('hd-Dnone');
            setTimeout(() => {
              giftErrorEl.classList.add('hd-Dnone');
            }, 6000);
            this.submitting = false;
            this.setAtcStockDisabled(false);
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const metafield = this.form.querySelector('input[name="properties[_additional_services]"]');
        if (templateSuffix == 'gift-card' && giftRadioValue === 'true') {
          formData.append('properties[From]', giftName);
          formData.append('properties[Recipient Name]', giftRName);
          formData.append('properties[Recipient Email Address]', giftEmail);
          formData.append('properties[Message]', giftComment);
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (metafield != null && metafield.value != '') {
                this.matressProduct(metafield);
              } else {
                this.cart.renderContents(response);
              }
            }
            (window.CE_API || (window.CE_API = [])).push(function () {
              // Set the "worth" and "currency" to the values you need.
              window.CE2.nextGoalConversionValue(
                '214a9bd1-f60a-4763-8bac-33b4c3070606',
                { worth: response.final_price, currency: 'GEB' }
              );
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.submitting = false;
            this.querySelector('.loading__spinner').classList.add('hidden');
            // Keep ATC disabled when remaining stock cannot cover the selected qty
            this.syncStockLimitState().then((canAdd) => {
              if (!this.error && canAdd) {
                this.setAtcStockDisabled(false);
              }
            });
            const quantityInputEl = this.getMainQuantityInput()?.closest('quantity-input');
            if (quantityInputEl && typeof quantityInputEl.refreshStockLimits === 'function') {
              quantityInputEl.refreshStockLimits();
            }
          });
      }

      // Function to validate email
      isValidEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }

      async ymalProduct(data) {
        let products = [];
        document.querySelectorAll('#complementaryProducts .product__slide') &&
          document.querySelectorAll('#complementaryProducts .product__slide').forEach(function (item) {
            if (item.querySelector('input[type=checkbox]:checked'))
              products.push({ id: `${item.querySelector('input[type=checkbox]:checked').value}`, quantity: 1 });
          });
        let formData = { items: products };
        if (products.length != 0) {
          fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((data) => {});
        }
      }

      async matressProduct(metafield) {
        const id = metafield.value;
        const matressProductId = this.form.querySelector('[name=id]').value;
        const sectionId = this.form.querySelector('[name="section-id"]').value;
        const productId = this.form
          .querySelector('input[name="properties[_additional_services]"]')
          .getAttribute('data-id');
        const metafieldformData = new FormData();
        metafieldformData.append('quantity', 1);
        metafieldformData.append('form_type', 'product');
        metafieldformData.append('utf8', '✓');
        metafieldformData.append('id', id);
        metafieldformData.append('properties[_matressProduct]', matressProductId);
        metafieldformData.append('product-id', productId);
        metafieldformData.append('section-id', sectionId);
        if (this.cart) {
          metafieldformData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          metafieldformData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const newconfig = fetchConfig('javascript');
        newconfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete newconfig.headers['Content-Type'];
        newconfig.body = metafieldformData;
        try {
          const data = await fetchJSON(`${routes.cart_add_url}.js`, newconfig);
          this.cart.renderContents(data);
        } catch (error) {
          console.error('Error processing the request:', error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      async getSwatchCountAndCheckInCart() {
        const data = await getCart();
        const cartItems = data.items;
        const swatchCount = cartItems
          .filter((item) => item.product_type === 'Swatch')
          .reduce((total, item) => total + item.quantity, 0);
        const isSwatchInCart = cartItems.some(
          (item) => item.product_type === 'Swatch' && item.handle === this.form.getAttribute('data-handle')
        );
        return { swatchCount, isSwatchInCart };
      }
    }
  );
}
